import { useState } from "react";
import { TBlockedIssuers, TBlockedIssuersOptions } from "./types";
import { generateInstallmentsPlans, validateFormInput } from "./util";
import { InstallmentsProps } from "../../pages/Installments/InstallmentsForm/types";

const ERROR_MSG = "Debe seleccionar una opción de financiamiento";

const useInstallments = (callback) => {
  const [errors, setErrors] = useState<any>({});

  const blockedIssuersBody: TBlockedIssuers = { 
    cardFilter: {
       issuer_name: {
          type: "block",
          value: []
       }
    } 
   };

  const handleSubmit = (event: React.FormEvent, blockedIssuers: TBlockedIssuersOptions) => {
    event.preventDefault();
    let error = {};
    let successValue = {};
    const formData = new FormData(event.target as HTMLFormElement);
    const result = generateInstallmentsPlans(formData.entries());

    const installmentsBody: InstallmentsProps = {
      installmentsPlans: result
    };

    for (const [key, value] of Object.entries(blockedIssuers)) {
      if (value) blockedIssuersBody.cardFilter.issuer_name.value.push(key);
    }

    for (const [key , value] of formData.entries()) {
      const isValid = validateFormInput(key, value as string);
      if (!isValid) {  
        error = {
          ...error,
          [key]: ERROR_MSG
        };
      } else {
        // @ts-ignore
        // eslint-disable-next-line
        const { [key]: val, ...rest } = error;
        error = { ...rest };

        successValue = {
          ...successValue,
          [key]: value
        };
      }
    }
    setErrors(error);  

    if (Object.keys(error).length === 0) {
      callback(installmentsBody, blockedIssuersBody);
    }
  };

  return {
    errors,
    handleSubmit
  };
};

export default useInstallments;
